import { Link } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  return (
<div
  className="relative flex flex-col h-screen items-center justify-center w-full min-h-[70vh] px-6 text-center text-white overflow-hidden"
  style={{
    background: `linear-gradient(to bottom, #2563eb, #000000)` // dark blue → black
  }}
>

      {/* Decoración de fondo */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" />

      {/* Foco inferior – más claro */}




      {/* Imagen */}
      <img
        src="/icons/error_404.png"
        alt="error 404"
        className="relative w-52 mb-8 drop-shadow-xl animate-fade-in-up hover:scale-105 transition-transform duration-500"
      />

      {/* Texto */}
      <h2 className="text-3xl font-semibold mb-3 tracking-tight">
        Algo se ha perdido en el camino
      </h2>

      <p className="max-w-md mb-8 leading-relaxed">
        Esta página no está donde debería, pero ya estamos trabajando para traerla de vuelta.
      </p>

      {/* Botón */}
      <Link
        to="/"
        className="
             relative inline-flex items-center justify-center
             px-8 py-3 w-64 rounded-lg
             border border-teal-600
             font-medium
             text-white dark:text-black
             bg-gradient-to-r from-teal-900 via-teal-500 to-teal-900
             dark:from-teal-500 dark:via-teal-100 dark:to-teal-300
             bg-[length:200%_200%]
             transition-all duration-700 ease-in-out
             hover:bg-[position:100%_50%]
             hover:shadow-lg hover:scale-[1.02]
           "
      >
        Volver al inicio
      </Link>


    </div>

  );
};

export default ErrorPage;
